import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby'
import * as DropdownMenuRadix from '@radix-ui/react-dropdown-menu';
import * as dropdownStyles from './dropdown-styles.module.scss';

const DropdownMenu = ({
    menuItems
}) => { 
 
  return (
    <DropdownMenuRadix.Root>
      <DropdownMenuRadix.Trigger asChild>
        <button type="button" className={dropdownStyles.IconButtonDd} aria-label="View Path Links" title="View Path Links" >
          ...
        </button>
      </DropdownMenuRadix.Trigger>

      <DropdownMenuRadix.Portal className={dropdownStyles.dropdownPortal}>
        <DropdownMenuRadix.Content className={dropdownStyles.DropdownMenuContent} sideOffset={5}>
          
          {
            menuItems.map((item) => {
                const itemSplit = item.split('==')
                const name = itemSplit[0]
                const link = itemSplit[1]
                return(
                        <DropdownMenuRadix.Item className={dropdownStyles.DropdownMenuItem} key={link}>
                            <span style={{color: 'var(--color-text-3)'}}>/ &nbsp;<Link to={`/${link}`}>{name}</Link></span>
                        </DropdownMenuRadix.Item>
                )
            }
               
            )
          }
         

        </DropdownMenuRadix.Content>
      </DropdownMenuRadix.Portal>
    </DropdownMenuRadix.Root>
  );
};

DropdownMenu.propTypes = {
    menuItems: PropTypes.array.isRequired
}

export default DropdownMenu;
